import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-8 sm:py-10 md:py-12" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center" data-id="element-34">
          <p className="text-white text-lg sm:text-xl font-bold mb-2 sm:mb-3" data-id="element-35">
            Info Ecommerce
          </p>
          <p className="text-sm sm:text-base" data-id="element-36">
            © {new Date().getFullYear()} Info Ecommerce. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}